import { cn } from '@/lib/utils'
import { Viewport } from './accountModel'

interface AccountContentProps {
  viewport: Viewport
  /** The nav row being shown, or null for the dashboard. */
  page: string | null
}

/**
 * The page beside the nav. Left empty below the heading on purpose: this
 * prototype asks where the agent sits in the chrome, and anything drawn in the
 * page competes with that question.
 */
export function AccountContent({ viewport, page }: AccountContentProps) {
  return (
    <div className={cn('flex flex-col gap-1 p-4', viewport === Viewport.DESKTOP && 'p-6')}>
      <h1 className="text-ink text-xl font-bold tracking-tight">{page ?? 'Dashboard'}</h1>
      {page === null ? (
        <p className="text-ink-500 text-sm">Tasks, summaries, and alerts from all Cai products</p>
      ) : (
        <p className="text-ink-400 text-sm">Not drawn in this prototype.</p>
      )}
    </div>
  )
}
